// Home to display "Pregunta"
import { MultipleQuestionEmp } from './MultipleQuestionEmp';
export const QuestionEmp = (optionsQuestion, handlerInfoClick, cursoColor, transTxt, audioQuestion, activeButton, history, fatherId, unitId, questionId, questionDes) => {
    let options;
    let optionsq;
    if(optionsQuestion!==''){
                
        let questionArr = [];
        let answerArr = [];
        let randomColor = '';
        let idArr = [];
        let idaArr = [];
        const questionClick = (e) => {
            // console.log('click',e.currentTarget.id,e.currentTarget.getAttribute("order"))
            const index = questionArr.indexOf(e.currentTarget.getAttribute("order"));
            if(index !== -1){
                questionArr.splice(index, 1);
                idArr.splice(index, 1);
                e.currentTarget.style.background = "white";
                e.currentTarget.style.color = "black";
                answerArr.splice(index, 1);
                if(idaArr.length>0){
                    let eleid = document.getElementById(idaArr[index])
                    eleid.style.background = "white";
                    eleid.style.color = "black";
                }
                
                idaArr.splice(index, 1);
            }
            else{
                questionArr.push(e.currentTarget.getAttribute("order"))
                idArr.push(e.currentTarget.id)
                randomColor = Math.floor(Math.random()*16777215).toString(16);
                e.currentTarget.style.color = "white";
                e.currentTarget.style.background = "#" + randomColor;
            }
            if(questions.length === idArr.length){
                document.getElementById('btnIngresar').removeAttribute("disabled");
                document.getElementById('btnIngresar').addEventListener('click', handlerMatchClick);
            }
            else{
                document.getElementById('btnIngresar').setAttribute("disabled", "");
            }
            // console.log('que',index,questionArr,idArr)
        }
        const AnswerClick = (e) => {
            if(randomColor !== ''){
                // console.log('click a',e.currentTarget.id,e.currentTarget.getAttribute("order"))
                const index = answerArr.indexOf(e.currentTarget.getAttribute("order"));
                if(index !== -1){
                    let eleid = document.getElementById(idArr[index])
                    eleid.style.background = "white";
                    eleid.style.color = "black";
                    answerArr.splice(index, 1);
                    idArr.splice(index, 1);
                    idaArr.splice(index, 1);
                    questionArr.splice(index, 1);
                    
                    answerArr.push(e.currentTarget.getAttribute("order"))
                    e.currentTarget.style.color = "white";
                    e.currentTarget.style.background = "#" + randomColor;
                    idaArr.push(e.currentTarget.id)
                }
                else{
                    answerArr.push(e.currentTarget.getAttribute("order"))
                    idaArr.push(e.currentTarget.id)
                    e.currentTarget.style.color = "white";
                    e.currentTarget.style.background = "#" + randomColor;
                }
                
                // console.log('ans',index,answerArr,idaArr)
                randomColor = ''
                if(questions.length === idaArr.length){
                    document.getElementById('btnIngresar').removeAttribute("disabled");
                    document.getElementById('btnIngresar').addEventListener('click', handlerMatchClick);
                }
                else{
                    document.getElementById('btnIngresar').setAttribute("disabled", "");
                }
            }
        }
        const handlerMatchClick = (e) => {
            if(options.length === answerArr.length){
                // console.log({questionArr})
                let ban = 0;
                questionArr.forEach((element, index) => {
                    // console.log(element)
                    if(element !== answerArr[index]){
                        ban = 1;
                    }
                    index++
                });
                if(ban === 0){
                    history( `/question-ok/${fatherId}/${unitId}/${questionId}`, {
                                        replace: true
                                    });
                }else{
                    history( `/question-fail/${fatherId}/${unitId}/${questionId}`, {
                        replace: true
                    });
                }
            }
            else{
                history( `/question-fail/${fatherId}/${unitId}/${questionId}`, {
                    replace: true
                });
            }
        };
        // console.log(optionsQuestion)
        let questions = [],
            answers = [];
        for (let i = 0, length = optionsQuestion.length; i < length; i++) {
            if (i % 2 === 0) {
                questions.push(optionsQuestion[i]);    
            } else {
                answers.push(optionsQuestion[i]);  
            }        
        }
        answers.sort((a, b) => {
            if (a.text_value < b.text_value) {
              return -1;
            }
          });
        options = questions.map(element => {
            return <MultipleQuestionEmp 
                key={ element.id }
                id={element.id}
                text_value={element.text_value}
                correct={element.correct}
                order={element.order}
                questionClick={questionClick}
            />
        });
        optionsq = answers.map((element,i) => {
            
            return <MultipleQuestionEmp 
                key={ element.id }
                id={element.id}
                text_value={element.text_value}
                correct={element.correct}
                order={element.order}
                questionClick={AnswerClick}
            />
        });

        const audioQ = (audioQuestion) => {
            if(audioQuestion){
                return(
                    <div>
                        <audio controls>
                            <source src={process.env.REACT_APP_ADMIN_URL+audioQuestion} type="audio/mpeg"></source>
                        </audio>
                    </div>
                )
            }
            
        }
        const actBut = (activeButton) => {
            if(activeButton===true){
                if(questions.length === idaArr.length){
                    return( <button id="btnIngresar" tabIndex="0" className="btn m-1 btn-block btn-wfp-main wfp--btn wfp--btn--primary btn-question-p" onClick={handlerMatchClick} style={{borderColor:  cursoColor,backgroundColor: cursoColor,color:  "#ffffff",}}>{transTxt.btn.emparejar.txt}</button>)
                }
                else{
                    return( <button id="btnIngresar" tabIndex="0" className="btn m-1 btn-block btn-wfp-main wfp--btn wfp--btn--primary btn-question-p" onClick={handlerMatchClick} style={{borderColor:  cursoColor,backgroundColor: cursoColor,color:  "#ffffff",}} disabled>{transTxt.btn.emparejar.txt}</button>)
                }
                
            }
            return (<button id="btnIngresar" tabIndex="0" className="btn m-1 btn-block btn-wfp-main wfp--btn wfp--btn--primary btn-question-p" onClick={handlerInfoClick} style={{borderColor:  cursoColor,backgroundColor: cursoColor,color:  "#ffffff",}}>{transTxt.btn.regresar.txt}</button>);
            
        }
       
        return (<>
            {audioQ(audioQuestion)}
            <div className="question-txt-description">{questionDes}</div>
            <div className="question-m-content">
            <div className="question-m-pre">    
                <div className="content-language"><br/>Pregunta a Emparejar:<br/><br/></div>
                {options}
            </div>
            <div className="question-m-res">  
                <div className="content-language"><br/>Escoge la Respuesta:<br/> <br/></div>
                {optionsq}
            </div>
           
            </div>
            <div className="course-enter">
                {actBut(activeButton)}
            </div>
            
            </>);
        
    }
    
    return null;
            
        
}

